export default __webpack_public_path__ + "static/media/how3.102e3832.png";